import {
  ADMIN_USERS_RECEIVED,
  ADMIN_USERS_UNLOADED
} from './types'

export default function advisors(state = [], action = {}){
  switch (action.type) {
    case ADMIN_USERS_RECEIVED:
      return action.users
    case ADMIN_USERS_UNLOADED:
      return []
    default:
      return state;
  }
}